import { usePage } from "@inertiajs/react";

// What the signed-in account may see and change, as the screens ask it.
//
// The map arrives with every page from ApplicationController's inertia_share — one entry per
// module the account holds, missing entirely where it holds nothing. `write` includes `read`,
// so a module set to write needs no second check to be visible.
//
// None of this enforces anything. The server refuses on every request — see Authorization —
// and this is only so a read-only account is spared buttons that would refuse it, and so the
// sidebar doesn't offer a screen that would bounce them straight back to the dashboard.
// Hiding a control is a courtesy; it is never the guard.

const RANK = { none: 0, read: 1, write: 2 };

function level(can, key) {
  return RANK[can?.[key]] ?? 0;
}

export function canRead(can, key) {
  return level(can, key) >= RANK.read;
}

export function canWrite(can, key) {
  return level(can, key) >= RANK.write;
}

// The hook every screen uses: `const { read, write, superAdmin } = usePermissions()`.
export function usePermissions() {
  const { auth } = usePage().props;
  const can = auth?.can ?? {};

  return {
    can,
    superAdmin: Boolean(auth?.user?.super_admin),
    read: (key) => canRead(can, key),
    write: (key) => canWrite(can, key),
  };
}
